import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { LazoChatTypingDTO } from "@/models/ai-chat/LazoChatTyping";
import { useEffect, useState } from "react";

// Using the user externalId as the key on our dictionary
type UserTypingList = {
  [key: string]: LazoChatTypingDTO;
};

interface ChatTypingProps {
  message: LazoChatTypingDTO | undefined;
}

export const LazoAIChatTypingComponent = ({ message }: ChatTypingProps) => {
  // State that stores a dictionary of users that typed in the chat during the session
  const [usersTyping, setUsersTyping] = useState<UserTypingList>({});
  // State used to refresh the dictionary and filter the ones that expired
  const [usersTypingRefresh, setUsersTypingRefresh] = useState<boolean>(false);

  // If the event is from the same user we ignore it, otherwise we update the dictionary
  const handleUserTypingEvent = (message: LazoChatTypingDTO) => {
    if (message.user.externalId! !== AuthService.getUser()?.externalId!) {
      const newUserTypingList: UserTypingList = { ...usersTyping };
      newUserTypingList[message.user.externalId!] = message;
      setUsersTyping(newUserTypingList);
    }
  };

  useEffect(() => {
    if (message) {
      handleUserTypingEvent(message);
    }
  }, [message]);

  // Loop created to trigger the useEffect that filters the expired typing events (as the setInterval loses the useStates updates)
  useEffect(() => {
    const intervalID = setInterval(() => {
      setUsersTypingRefresh((prevValue) => !prevValue);
    }, 1000);
    return () => clearInterval(intervalID);
  }, []);

  // Functionality that filters the outdated typing events
  useEffect(() => {
    if (Object.keys(usersTyping).length > 0) {
      const filteredList: UserTypingList = {};

      Object.entries(usersTyping).forEach(([key, value]) => {
        if (value.timeToLive > new Date().getTime()) {
          filteredList[key] = value;
        }
      });

      setUsersTyping(filteredList);
    }
  }, [usersTypingRefresh]);

  return (
    <>
      {Object.keys(usersTyping).length > 0 && (
        <p
          style={{
            fontSize: 12,
            alignSelf: "baseline",
            paddingLeft: "0.875rem",
            marginTop: 20,
          }}
        >
          <b>
            {Object.keys(usersTyping).length <= 2
              ? `${Object.entries(usersTyping)
                  .map(([key, value]) => value.user.firstName + " " + value.user.lastName)
                  .join(" and ")}`
              : "Many users"}
          </b>{" "}
          {`${Object.keys(usersTyping).length > 1 ? "are" : "is"}`} typing...
        </p>
      )}
    </>
  );
};
